export class MouseScroll{
  target!:HTMLElement
  listLeft = 0
  isMouseDown:boolean = false
  isMouseMoved:boolean = false
  startLeft = 0
  mouseDonwLeft = 0
  mouseMoveLeft = 0
  vx = 0
  isMounted:boolean = false
  _mouseDownListener= (e:MouseEvent)=>this._mousedown(e)
  _mouseUpListener = (e:MouseEvent)=>this._mouseup(e)
  _mouseMoveListener = (e:MouseEvent)=>this._mousemove(e)
  _setTimeoutListener =()=>this._setTimeout()
  init(target:HTMLElement){
    console.log('mount',target)
    this.target = target
    this.target.addEventListener('mousedown',this._mouseDownListener)
    document.addEventListener('mouseup',this._mouseUpListener)
    document.addEventListener('mousemove',this._mouseMoveListener)
    this.isMounted = true
    window.setTimeout(this._setTimeoutListener,30)
  }
  dispose(){
    this.isMounted = false
    this.target.removeEventListener('mousedown',this._mouseDownListener)
    document.removeEventListener('mouseup',this._mouseUpListener)
    document.removeEventListener('mousemove',this._mouseMoveListener)
  }
  _mouseup(e:MouseEvent){
    this.isMouseDown = false
  }
  _mousedown(event:MouseEvent){
    this.vx = 0
    this.mouseMoveLeft = event.clientX
    this.isMouseMoved = false
    this.mouseDonwLeft = event.clientX
    this.isMouseDown = true
    this.startLeft = this.target.scrollLeft
  }
  _mousemove(e:MouseEvent){
    if(this.isMouseDown){
      this.isMouseMoved = true
      this.vx = (this.mouseMoveLeft - e.clientX) * 4
      this.mouseMoveLeft = e.clientX
      const diff = e.clientX - this.mouseDonwLeft
      this.listLeft = diff
      this.target.scrollLeft = this.startLeft - diff
    }
  }
  _setTimeout(){
    if(this.isMounted){return}
    if(!this.isMouseDown && this.vx !== 0){
       const next =this.vx + this.target.scrollLeft
       this.target.scrollLeft = Math.floor(next)
       this.vx *= 0.8
       if(Math.abs(this.vx) < 0.5){
         this.vx = 0
       }
    }
    if(this.isMounted) {
      window.setTimeout(this._setTimeoutListener,17)
    }
  }
}
